import { getStringToWords, stringWordsAddActive } from './string-to-characters.js';
import elmntIO from './elmnt-io.js';

export function splitWordAnim() {
    const $elmnts = document.querySelectorAll('.split-word-anim');

    if ( !$elmnts.length ) return;

    $elmnts.forEach($el => {
        const text = $el.textContent;
        const html = getStringToWords(text);
        $el.innerHTML = html;
        $el.setAttribute('data-io', '');
        $el.setAttribute('data-io-threshold', '0');
        $el.setAttribute('data-io-margin', '-10% 0px -10% 0px');

        elmntIO($el, handleEntry, handleExit);
    });

    function handleEntry(entry) {
        stringWordsAddActive(entry.target, {interval: 90});
    }

    function handleExit(entry) {
        const $words = entry.target.querySelectorAll('.word');
        $words.forEach($word => {
            $word.classList.remove('active');
        });
    }
}